(function () {
  'use strict';
  angular.module('MktzapApp.Directives')
    .directive('rotate', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var r = 'rotate(' + attrs.degree + 'deg)';
          element.css({
            '-moz-transform': r,
            '-webkit-transform': r,
            '-o-transform': r,
            '-ms-transform': r
          });
        }
      }
    });
})();
